import type { Components } from '@mui/material'

export const OmuiDetailTooltip: NonNullable<Components['OmuiDetailTooltip']> = {
  defaultProps: {
    placement: 'right',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.bg.surface.elevated,
      border: `${theme.strokeWidth.strong} solid ${theme.palette.border.subtle}`,
      borderRadius: theme.shape['radius-md'],
      boxShadow: theme.customShadows.md,
      minWidth: 260,
      maxWidth: 360,
      color: theme.palette.text.default,
      textAlign: 'left',
    }),
    header: ({ theme }) => ({
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(3),
      padding: theme.spacing(4),
    }),
    avatar: {
      display: 'flex',
      flexShrink: 0,
    },
    titleGroup: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      flex: 1,
      minWidth: 0,
    }),
    title: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    body: ({ theme }) => ({
      padding: theme.spacing(4),
    }),
    footer: ({ theme }) => ({
      padding: theme.spacing(4),
    }),
  },
}
